import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import WGEventFields from '@jumbo/Dashboards/WordGameEvents/WGEventFields';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.wordGameEvents'} />, link: '/wordGame/events' },
  { label: <IntlMessages id={'pages.createWGEventPage'} />, isActive: true },
];

const CreateWGEvent = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.createWGEventPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <WGEventFields />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default CreateWGEvent;